import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NAV_LINKS, CV_URL } from "../data";
import Monogram from "./Monogram";

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -64, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-300 ${
        scrolled || open
          ? "bg-parchment/85 backdrop-blur-md border-b border-line"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-monogram-logo"
          className="flex items-center gap-3 group"
          aria-label="Irene Chen — back to top"
        >
          <Monogram className="w-9 h-9 transition-transform duration-500 group-hover:rotate-[-8deg]" />
          <span className="font-serif italic text-lg text-ink">Irene Chen</span>
        </a>

        <nav className="hidden md:flex items-center gap-7" aria-label="Primary">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-sm font-sans text-ink2 hover:text-terra transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            href={CV_URL}
            download="Irene-Chen-CV.pdf"
            data-testid="nav-cta-download-cv"
            className="text-sm font-sans font-medium text-terra border border-terra/50 rounded-full px-4 py-1.5 hover:bg-terra hover:text-parchment transition-colors duration-300"
          >
            Download CV
          </a>
        </nav>

        <button
          type="button"
          className="md:hidden p-2 text-ink"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-expanded={open}
          aria-label="Toggle navigation menu"
        >
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="1.5">
            {open ? (
              <path d="M5 5l12 12M17 5L5 17" strokeLinecap="round" />
            ) : (
              <path d="M3 6h16M3 11h16M3 16h16" strokeLinecap="round" />
            )}
          </svg>
        </button>
      </div>

      {open && (
        <nav className="md:hidden border-t border-line bg-parchment/95 backdrop-blur-md" aria-label="Mobile">
          <div className="px-4 py-4 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-mobile-link-${l.href.slice(1)}`}
                onClick={() => setOpen(false)}
                className="text-base font-sans text-ink2 hover:text-terra py-2 transition-colors"
              >
                {l.label}
              </a>
            ))}
            <a
              href={CV_URL}
              download="Irene-Chen-CV.pdf"
              data-testid="nav-mobile-cta-download-cv"
              className="text-base font-sans font-medium text-terra py-2"
            >
              Download CV
            </a>
          </div>
        </nav>
      )}
    </motion.header>
  );
};

export default Nav;
